import { gql } from "apollo-angular";

export const GETALL_TEST_ANALYSIS_QUERY_PAGINATED = gql`query configuratorAllTestAnalysisPagination($Company: String, $RegBy: String, $OrgGroup: String, $Page: Int, $PageSize: Int) {
  configuratorAllTestAnalysisPagination(Company: $Company, RegBy: $RegBy, OrgGroup: $OrgGroup, Page: $Page, PageSize: $PageSize) {
      Version
      Uid
      ItemNo
      Name
      ModifiedBy
      ModificationTime
      LockedTime
      LockedBy
      CreationTime
      CreatedBy
      Comment
      ApprovedForTestLevel
      ApprovalStatus
      Approval {
          Id
          Status
          ItemVersion
      }
  }
}
`

export const GETALL_TEST_ANALYSIS_QUERY = gql`query configuratorAllTestAnalysis($Company: String, $RegBy: String, $OrgGroup: String) {
    configuratorAllTestAnalysis(Company: $Company, RegBy: $RegBy, OrgGroup: $OrgGroup) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
        Approval {
            Id
            Status
            ItemVersion
        }
    }
  }
  `

  export const GET_TEST_ANALYSIS_QUERY = gql`query configuratorTestAnalysisById($Uid: String!) {
    configuratorTestAnalysisById(Uid: $Uid) {
        responseMessages
        returnValue
        success
    }
  }
  `

  export const GET_TEST_ANALYSIS_UI_TEMPLATE_QUERY = gql`query configuratorTestAnalysisUiTemplate {
    configuratorTestAnalysisUiTemplate {
        Name
        Category
        DefaultValue
        FieldType
        IsMultiValue
        HasHierarchyValues
        IsReadOnly
        Label
        IsRequired
        Order
        Tooltip
        ValueList
    }
  }
  `
export const GET_TEST_ANALYSIS_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorTestAnalysisSearchUiTemplate {
    configuratorTestAnalysisSearchUiTemplate {
        Name
        Label
        Category
        DefaultValue
        Order
        FieldType
        Tooltip
        IsReadOnly
        IsRequired
        IsMultiValue
        HasHierarchyValues
        ValueList
    }
  }
  `

export const SEARCH_TEST_ANALYSIS_QUERY = gql`query configuratorSearchTestAnalysis($TestAnalysis: TestAnalysisInput) {
  configuratorSearchTestAnalysis(TestAnalysis: $TestAnalysis) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
}
`
  